module.exports = __webpack_public_path__ + "img/SN.55543faa.svg";